import {
  DELEGATION_PERMISSION_OPTIONS,
  hasDelegationPermission,
  togglePermission,
} from "../../../constants/delegationPermissions";

interface DelegationPermissionsFieldProps {
  permissions: number;
  onChange: (permissions: number) => void;
  disabled?: boolean;
  idPrefix?: string;
  isRequired?: boolean;
}

const DelegationPermissionsField = ({
  permissions,
  onChange,
  disabled = false,
  idPrefix = "delegation-perm",
  isRequired = false,
}: DelegationPermissionsFieldProps) => (
  <fieldset disabled={disabled} className="vstack gap-2">
    <legend className="form-label fs-6 fw-semibold mb-2">
      Rettigheder
      {isRequired ? (
        <span className="text-danger" aria-hidden="true">
          {" *"}
        </span>
      ) : null}
    </legend>
    {DELEGATION_PERMISSION_OPTIONS.map(({ flag, label }) => {
      const inputId = `${idPrefix}-${flag}`;
      return (
        <div className="form-check" key={flag}>
          <input
            className="form-check-input"
            type="checkbox"
            id={inputId}
            checked={hasDelegationPermission(permissions, flag)}
            onChange={(e) =>
              onChange(togglePermission(permissions, flag, e.target.checked))
            }
            disabled={disabled}
          />
          <label className="form-check-label" htmlFor={inputId}>
            {label}
          </label>
        </div>
      );
    })}
  </fieldset>
);

export default DelegationPermissionsField;
